var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-button-wrapper" },
    [
      _c(
        "a-popover",
        {
          attrs: {
            trigger: "click",
            placement: "bottom",
            overlayClassName: "automation-popover zero-padding",
          },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c("template", { slot: "content" }, [
            _c(
              "div",
              { staticClass: "automation-list" },
              [
                _vm._l(_vm.automations, function (automation) {
                  return _c(
                    "div",
                    {
                      key: automation.id,
                      staticClass: "automation-item",
                      on: {
                        click: function ($event) {
                          return _vm.selectAutomation(automation)
                        },
                      },
                    },
                    [
                      _c("atomic-power", {
                        staticClass: "myIcon ml-2",
                        staticStyle: {
                          fill: "var(--color-icon-primary-default)",
                        },
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(automation.name) +
                          "\n                "
                      ),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c("a-divider"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "automation-item new",
                    on: { click: _vm.showCreateAutomationModal },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.newAutomation")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "SupsisButton",
            { staticClass: "automation-trigger-button" },
            [
              _c("atomic-power", {
                staticClass: "myIcon",
                staticStyle: { fill: "var(--color-icon-primary-default)" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("message.automations")))]),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.createAutomationModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.createProfileAutomation"),
                "show-footer": false,
              },
              on: {
                close: function ($event) {
                  _vm.createAutomationModalVisible = false
                },
                cancel: function ($event) {
                  _vm.createAutomationModalVisible = false
                },
              },
            },
            [
              _c("a-alert", {
                staticClass: "mb-4",
                attrs: {
                  type: "info",
                  "show-icon": "",
                  message: _vm.$t("message.profileButtonClicked"),
                  description: _vm.$t("message.profileButtonDescription"),
                },
              }),
              _vm._v(" "),
              _c("a-input", {
                attrs: { placeholder: _vm.$t("message.automationName") },
                model: {
                  value: _vm.newAutomationName,
                  callback: function ($$v) {
                    _vm.newAutomationName = $$v
                  },
                  expression: "newAutomationName",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-4 text-right" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "mr-2",
                      on: {
                        click: function ($event) {
                          _vm.createAutomationModalVisible = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.createAutomation },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.create")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }